import localforage from "localforage";

export const editor = {
  methods: {
    reset_editor: function(){
      this.$store.commit("editor/setSearchTarget", "source");
      this.$store.commit("editor/setSearchString", "");
      this.$store.commit("editor/setReplaceString", "");
      this.$store.commit("editor/setSearchFiltering", false);
      this.$store.commit("setSideMenu", this.$store.getters["editor/backup_side_menu"]);
      this.$store.commit("editor/setBackupSideMenu", null);
      for(var tab of this.$store.getters["editor/tabs"]){
        this.$store.dispatch("editor/" + tab.id + "/deleteContent");
        this.$store.dispatch("editor/" + tab.id + "/resetHistory");
      }
      this.$store.commit("editor/setTabs", []);
      localforage.config({
        name: this.$store.getters.domain,
        storeName: "editor"
      });
      localforage.ready()
      .then(async () => {
        localforage.clear()
          .then(() => {
            localforage.removeItem("utime");
          });
        // .catchは一段上の方へ飛んでいく
      })
      .catch((e) => {
        // エラールート
        if(this.$store.getters.debug){
          console.error("localforage.ready/dropInstance:" + e);
        }
        this.$store.commit("setNotification", {
          type: "warning",
          message: {
            eid: "E191113:00000006",
            param: {}
          }
        });
      });
    },
    filter_sentence: function(sentence){
      // status
      var status = this.filter_status.indexOf(sentence.data.status) >= 0;
      // searched
      var searched = false;
      if(!this.search_filtering || !this.search_string || this.search_string === ""){
        searched = true;
      }else{
        var search_string = this.search_string;
        var search_sentence = sentence.data[this.search_target].sentence;
        if(!(this.search_case_sensitive)){
          search_string = search_string.toLowerCase();
          search_sentence = search_sentence.toLowerCase();
        }
        searched = search_sentence.indexOf(search_string) >= 0;
      }
      // memo_exists
      var memo_exists = true;
      if(this.$store.getters["editor/filter_memo_exists"]){
        memo_exists = (sentence.data.memo.sentence !== "");
      }
      // return
      return status && searched && memo_exists;
    },
    get_prev: function(module){
      var prev = "/" + module;
      if(this.$route.query.referer){
        var referers = this.$route.query.referer.split(":");
        prev = referers.pop();
        if(referers.length > 0){
          prev += "?referer=" + encodeURIComponent(referers.join(":"));
        }
      }
      return prev;
    },
  }
}

export const mapContentGetters = function(id_name, getters){
  var res = {};
  for(var key of getters){
    res[key] = (function(id_name, key){
      return function(){
        return this.$store.getters["editor/" + this[id_name] + "/" + key];
      }
    })(id_name, key);
    res[key].vuex = true;
  }
  return res;
};
